// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__dVyML","mainContainer":"Layout_mainContainer__2yQVO","pageContainer":"Layout_pageContainer__wEKfM","sectionContainer":"Layout_sectionContainer__OQ4Wr"};